import _ from 'lodash'
import { Suspense } from 'react'

import BIMESSAGES from 'core/data-model/constants/bi-messages'
import MESSAGES from 'core/data-model/constants/messages'
import { renderBIAge } from 'core/service/insured/age'
import { formatNumber } from 'core/service/lib/number-format'
import { hasAsteriskFromRiders } from 'core/service/rider/benefits/benefit-data'
import { getServiceWrapper } from 'core/service-wrapper'
import WholeLife25PLBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits-whole-life-25pl'

import SummaryTable from './summary-table'

const renderGraph = (basicPlanCode, code) => {
  const serviceWrapper = getServiceWrapper()
  const className = `graph-${basicPlanCode}`
  return (
    <Suspense fallback={null}>
      {(() => {
        switch (basicPlanCode) {
          case '20P10':
            return serviceWrapper.renderGraph('20P10', className)
          case '25P15':
            return serviceWrapper.renderGraph('25P15', className)
          case '20P10S':
            return serviceWrapper.renderGraph('20P10S', className)
          case '25P15S':
            return serviceWrapper.renderGraph('25P15S', className)
          case '12PL':
            return serviceWrapper.renderGraph('12PL', className)
          case 'WLNP85':
            return serviceWrapper.renderGraph('WLNP85', className)
          case 'PLB05':
            return serviceWrapper.renderGraph('PLB05', className)
          case 'PLB10':
            return serviceWrapper.renderGraph('PLB10', className)
          case 'PLB12':
            return serviceWrapper.renderGraph('PLB12', className)
          case 'PLB15':
            return serviceWrapper.renderGraph('PLB15', className)
          case 'LR05':
            return serviceWrapper.renderGraph('LR05', className)
          case 'CIWLM39':
            return serviceWrapper.renderGraph('CIWLM39', className)
          case 'CIWLM50':
            return serviceWrapper.renderGraph('CIWLM50', className)
          case 'CIWLM60':
            return serviceWrapper.renderGraph('CIWLM60', className)
          case 'CIWLS39':
            return serviceWrapper.renderGraph('CIWLS39', className)
          case 'CIWLS50':
            return serviceWrapper.renderGraph('CIWLS50', className)
          case 'CIWLS65':
            return serviceWrapper.renderGraph('CIWLS65', className)
          case 'W99FU06':
            return serviceWrapper.renderGraph('W99FU06', className)
          case 'W99FU12':
            return serviceWrapper.renderGraph('W99FU12', className)
          case 'W99U18W':
            return serviceWrapper.renderGraph('W99U18W', className)
          case 'W99H18W':
            return serviceWrapper.renderGraph('W99H18W', className)
          case 'W99FU18':
            return serviceWrapper.renderGraph('W99FU18', className)
          case 'W99FH18':
            return serviceWrapper.renderGraph('W99FH18', className)
          case 'W99FU99':
            return serviceWrapper.renderGraph('W99FU99', className)
          case 'W99FH99':
            return serviceWrapper.renderGraph('W99FH99', className)
          case 'W99F99H':
            return serviceWrapper.renderGraph('W99F99H', className)
          case 'W99F99M':
            return serviceWrapper.renderGraph('W99F99M', className)
          case 'H99F06A':
            return serviceWrapper.renderGraph('H99F06A', className)
          case 'H99F12A':
            return serviceWrapper.renderGraph('H99F12A', className)
          case 'H99F18A':
            return serviceWrapper.renderGraph('H99F18A', className)
          case 'W99F06A':
            return serviceWrapper.renderGraph('W99F06A', className)
          case 'WLF09L':
            return serviceWrapper.renderGraph('WLF09L', className)
          case 'WLF09H':
            return serviceWrapper.renderGraph('WLF09H', className)
          case 'WLF19L':
            return serviceWrapper.renderGraph('WLF19L', className)
          case 'WLF19H':
            return serviceWrapper.renderGraph('WLF19H', className)
          case 'WLF99L':
            return serviceWrapper.renderGraph('WLF99L', className)
          case 'WLF99H':
            return serviceWrapper.renderGraph('WLF99H', className)
          case 'WLF99HX':
            return serviceWrapper.renderGraph('WLF99HX', className)
        }
      })()}
    </Suspense>
  )
}

const renderProductBenefits = (displayProduct, policyValue, sumAssured) => {
  const basicPlanCode = _.get(displayProduct, 'basicPlanCode')

  if (basicPlanCode === '25PL') {
    return (
      <div className="d-md-none d-lg-none">
        <WholeLife25PLBenefits displayProduct={displayProduct} policyValue={policyValue} sumAssured={sumAssured} />
      </div>
    )
  }

  return ''
}

const ProfileSnapshot = ({
  displayProduct,
  riders,
  genderLabel,
  age,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  policyValue,
  sumAssured,
  basicPremium,
  totalPremium,
  selectedModelFactorLabel,
  hasNonLevelRider,
  hasShowDisclaimerRiderAsterisk,
  totalRiderPremium,
  profileSummaryHeader,
  summaryTableHeader,
  showGraph = true,
  selectedModelFactorID,
  isNewAsteriskOfSummaryMainContract,
  isReviseQQ,
  campaignDiscountMessage,
  isCheckHaveRiderCampaignDiscountActive,
  riderCampaignDiscountBIMessage,
  isCheckHaveBasicCampaignDiscountActive,
}) => {
  return (
    <div id="profile-summary" className="snapshot group">
      <h2>
        {_.isFunction(profileSummaryHeader)
          ? // $$FlowFixMe
            profileSummaryHeader({
              displayProduct,
              riders,
              genderLabel,
              age,
              calculatedCoveragePeriod,
              calculatedPaymentPeriod,
              sumAssured,
              basicPremium,
              totalPremium,
              selectedModelFactorLabel,
              hasNonLevelRider,
              totalRiderPremium,
            })
          : profileSummaryHeader}
      </h2>
      <div className="profile">
        <div className="info gender">
          <p className="label">{MESSAGES.GENDER}</p>
          <p className="value">{genderLabel}</p>
        </div>
        <div className="info age">
          <p className="label">{MESSAGES.AGE}</p>
          <p className="value">{renderBIAge(age, isReviseQQ)}</p>
        </div>
        <div className="info coverage-period">
          <p className="label">{BIMESSAGES.COVERAGE_PERIOD}</p>
          <p className="value">
            {calculatedCoveragePeriod} {MESSAGES.TIME_UNIT_YEAR}
          </p>
        </div>
        <div className="info payment-period">
          <p className="label">{BIMESSAGES.PREMIUM_PAYMENT_PERIOD}</p>
          <p className="value">
            {selectedModelFactorID === 'model-factor_5'
              ? selectedModelFactorLabel
              : calculatedPaymentPeriod + ' ' + MESSAGES.TIME_UNIT_YEAR}
          </p>
        </div>
      </div>
      <div className="coverage">
        <div className="info sum-assured">
          <p className="label">{BIMESSAGES.BASIC_PLAN_SUM_ASSURED}</p>
          <p className="value">
            {formatNumber(sumAssured)} {MESSAGES.BAHT}
          </p>
        </div>
        <div className="info model-factor">
          <p className="label">{MESSAGES.PAYMENT_MODE}</p>
          <p className="value">{selectedModelFactorLabel}</p>
        </div>
      </div>
      <div className="coverage">
        <div className="info basic-premium">
          <p className="label">{BIMESSAGES.BASIC_PREMIUM}</p>
          <p className="value">
            {formatNumber(basicPremium, 2)} {MESSAGES.BAHT}
          </p>
        </div>
        <div className="info rider-premium">
          <p className="label">
            {BIMESSAGES.TOTAL_RIDER_PREMIUM}
            {hasAsteriskFromRiders(riders) ? '*' : ''}
          </p>
          <p className="value">
            {formatNumber(totalRiderPremium, 2)} {MESSAGES.BAHT}
            {/*{totalRiderPremium(riders)}*/}
          </p>
        </div>
        <div className="info total-premium">
          <p className="label">{BIMESSAGES.TOTAL_PREMIUM_FIRST_PREMIUM}</p>
          <p className="value">
            {formatNumber(totalPremium, 2)} {MESSAGES.BAHT}
          </p>
        </div>
        <div className="rider-campaign-discount-message">
          {campaignDiscountMessage && campaignDiscountMessage.length > 0
            ? campaignDiscountMessage[1]?.replace(/\n/g, '')
            : ''}
        </div>
        {isCheckHaveRiderCampaignDiscountActive && riderCampaignDiscountBIMessage.length > 0
          ? riderCampaignDiscountBIMessage.map((riderMsg, index) => {
              return (
                <div key={index} className="rider-campaign-discount-message">
                  {riderMsg}
                </div>
              )
            })
          : ''}
      </div>
      {showGraph && displayProduct ? renderGraph(displayProduct.basicPlanCode, _.get(displayProduct, 'code')) : ''}
      {displayProduct ? renderProductBenefits(displayProduct, policyValue, sumAssured) : ''}
      <SummaryTable
        displayProduct={displayProduct}
        riders={riders}
        age={age}
        calculatedCoveragePeriod={calculatedCoveragePeriod}
        calculatedPaymentPeriod={calculatedPaymentPeriod}
        basicPremium={basicPremium}
        totalPremium={totalPremium}
        basicSumAssured={sumAssured}
        hasNonLevelRider={hasNonLevelRider}
        hasShowDisclaimerRiderAsterisk={hasShowDisclaimerRiderAsterisk}
        selectedModelFactorID={selectedModelFactorID}
        selectedModelFactorLabel={selectedModelFactorLabel}
        summaryTableHeader={summaryTableHeader}
        isNewAsteriskOfSummaryMainContract={isNewAsteriskOfSummaryMainContract}
        isCheckHaveBasicCampaignDiscountActive={isCheckHaveBasicCampaignDiscountActive}
        campaignDiscountMessage={campaignDiscountMessage}
      />
    </div>
  )
}

export default ProfileSnapshot
